import { Alert, Layout, Button, Row, Col } from 'antd';
import React from 'react';
import { useNavigate } from "react-router-dom";

const MyError = ({error}) => {
  const navigate = useNavigate();
  console.log(error.code)
  console.log(error.name)
  const handleClick = () => {
    window.location.reload();
  }

  let message = ''
  if(error.code === 'unavailable') {
    message = 'Please, check your internet connection or try again later'
  }

  return (
    <Layout style={{height:"100vh", flexDirection:"row", alignItems:"center"}}>
      <Layout >
        <Row>
          <Col span={12} offset={6}>
            <Alert
              style={{wordBreak:"break-all", whiteSpace:"pre-wrap"}}
              showIcon
              type="error"
              message={error.code || error.name}
              description={message || error.message}
            />
            <Button
              type="primary"
              onClick={handleClick}
            >
              Перезагрузить
            </Button>
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
};

export default MyError;
